import { Component, OnInit } from '@angular/core';
import { Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';
import { LoginPage } from '../pages/user/login';
import { WhSummaryPage } from '../pages/backoffice/overall/summary/index';
import { TicketsPage } from '../pages/backoffice/tickets';
import { AuthService } from './../providers/auth-service';
import { SearchParcel } from '../pages/qdb/search-parcel/index';

@Component({
  templateUrl: 'app.html'
})
export class MyApp implements OnInit {
  rootPage: any;

  constructor(platform: Platform, statusBar: StatusBar, splashScreen: SplashScreen, private auth: AuthService,
  ) {
    platform.ready().then(() => {
      statusBar.styleDefault();
      splashScreen.hide();
    });
  }

  ngOnInit() {
    if (window.localStorage.getItem('user')) {
      this.rootPage = SearchParcel;
    }
    else {
      this.rootPage = LoginPage;
    }
  }
}




// WEBPACK FOOTER //
// ./src/app/app.component.ts